import { render, staticRenderFns } from "./ReportDetailComponent.vue?vue&type=template&id=2d95d29a&scoped=true&"
import script from "./ReportDetailComponent.vue?vue&type=script&lang=js&"
export * from "./ReportDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailComponent.vue?vue&type=style&index=0&id=2d95d29a&prod&lang=css&"
import style1 from "./ReportDetailComponent.vue?vue&type=style&index=1&id=2d95d29a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95d29a",
  null
  
)

export default component.exports